import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteOutlined } from '@ant-design/icons';
import { theme, message, Popconfirm } from 'antd';
import { RootState } from 'store/configureStore';
import { solutionsOp } from 'store/ducks/Solutions';
import { complianceEstOp } from 'store/ducks/ComplienceEst';
import { ITextAreaBoxProps } from 'store/ducks/Solutions/types';
import CustomTextarea from '../CustomTextarea';
import Helpers from 'utils/Helpers';
import * as Styled from './TextAreaBoxSolutions.styled';

interface IPopoverState {
  [id: number | string]: boolean;
}

const cancel = () => {
  message.error('Solution was not deleted');
};

const { useToken } = theme;

export const TextAreaBoxSolutions: React.FC<ITextAreaBoxProps> = ({
  solutions,
  solId
}) => {
  const { token } = useToken();
  const dispatch = useDispatch();

  const { commentsData, lang, scheme, orgContext } = useSelector(
    (state: RootState) => ({
      commentsData: state.complianceEst.commentsData,
      lang: state.global.lang,
      scheme: state.global.scheme,
      orgContext: state.global.hierarchicalLevelsScope
    })
  );

  const filterParams = Helpers.toApiFilters(orgContext);

  const [popoverState, setPopoverState] = useState<IPopoverState>({});

  const handleDeleteClick = () => {
    const hasFilters = Object.keys(filterParams).length > 0;
    if (!orgContext || Object.keys(orgContext).length === 0) return;

    if (!hasFilters) return;

    solutionsOp.deleteSolution(solutions.sol_id).then(() => {
      solutionsOp.fetchSolutions(lang, filterParams).then((data) => {
        dispatch(solutionsOp.setSolutions(data));
      });
    });
  };

  const handleSolutionChange = (value: string) => {
    dispatch(
      solutionsOp.editSolutionValue(solId, solutions, 'sol_desc', value)
    );
    dispatch(complianceEstOp.setSaveDisabled(false));
  };

  const hide = (id: number | string) => {
    if (!id) return;

    setPopoverState((prevState) => ({
      ...prevState,
      [id]: false
    }));
  };

  // const drawComments = () => {
  //   const filteredComments = commentsData?.length
  //     ? commentsData.filter(
  //         (commentsDataItem: CommentItem) =>
  //           commentsDataItem.res_table_pk_ref === solutions.sol_id
  //       )
  //     : [];

  //   return (
  //     <>
  //       <CommentSection
  //         reqId={solutions.sol_id}
  //         data={filteredComments}
  //         tableRef={CommentTable.SOLUTIONS}
  //       />
  //       <a onClick={() => hide(Number(solutions.sol_id))}>Close</a>
  //     </>
  //   );
  // };

  const handleOpenChange = (id: number | string) => {
    if (!id) return;

    setPopoverState((prevState) => ({
      ...prevState,
      [id]: !prevState[id]
    }));
  };

  return (
    <Styled.TextAreaElementsContainer>
      <Styled.TextAreaElementsContainer>
        <CustomTextarea
          key={solId}
          placeholder='Type Solution'
          defaultValue={solutions.sol_desc}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
            handleSolutionChange(e.target.value)
          }
        />
        <Styled.StyledButtonSection token={token}>
          {/* Comment section hidden
          <Popover
            placement='leftBottom'
            trigger='click'
            content={drawComments}
            title='Comments'
            open={!!(solId && popoverState[solId])}
            onOpenChange={() => handleOpenChange(solId)}
          >
            <CustomIconButton
              type='primary'
              shape='circle'
              icon={<CommentOutlined />}
              size='small'
              cursor='pointer'
            />
          </Popover>
          */}
          <Popconfirm
            title='Delete the solution'
            description='Are you sure to delete this solution?'
            onConfirm={handleDeleteClick}
            onCancel={cancel}
            okText='Yes'
            cancelText='No'
          >
            <Styled.StyledCustomIconButton
              token={token}
              scheme={scheme}
              type='primary'
              shape='circle'
              icon={<DeleteOutlined />}
              cursor='pointer'
              size='small'
            />
          </Popconfirm>
        </Styled.StyledButtonSection>
      </Styled.TextAreaElementsContainer>
    </Styled.TextAreaElementsContainer>
  );
};
